module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('h2', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openSidebar()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("contact_mail")]), _vm._v(" "), _c('span', [_vm._v("Contact")])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "mailto:hello@timganter.io"
    }
  }, [_vm._v("hello@timganter.io")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//twitter.com/timganter"
    }
  }, [_vm._v("@timganter")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/timganter"
    }
  }, [_vm._v("LinkedIn")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4612bbcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/Contact.vue
// module id = 432
// module chunks = 1